module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "chapter-2",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("TWO")])])]), _vm._v(" "), _c('h2', {
    staticClass: "element-subtitle case-upper"
  }, [_vm._v("6 APRIL 1979")])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "chapter-2-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-r"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("R")]), _vm._v("ebecca and Pamela had first met soon after Pamela’s family moved to Leeds in 1961. On Pamela’s first morning at Roundhay High School, the sixth form were informed that something terrible had happened in the Ferguson family during the summer and that they were not to ask Rebecca about it. Later, another girl told Pamela precisely how Rebecca’s dad had “topped himself” in their garage. Within weeks, Pamela and Rebecca had become firm friends.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The two women embrace in front of the Majestic Hotel reception desk. Although Rebecca is still thinking about the news on the radio, she tells Pamela that they’re going to have a ball. One or two minutes are spent cooing over the opulence of the grand lobby before they check into their rooms. Later that afternoon, they’re sitting in Bettys Tea Rooms. They admire the rows of delicious-looking jam on the dark panelled shelving and agree how terrific it is to be in contact once again.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“It was nobody’s fault we lost touch when you moved to Nottingham,” Rebecca says, looking through the huge window into a small park over the road. “Except you never did give me your new phone number,” she adds, raising her eyebrows quizzically.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I know. And I kept meaning to, so I was to blame.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Maybe...”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“But Davina wouldn’t have welcomed another woman ringing me at home.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Like that, was it?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela nods, smiles grimly. A young man with a military haircut delivers teas and cakes to their table, bowing slightly before departing. Rebecca looks back across the road to the park.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Awful news this morning, wasn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Terrible – absolutely terrible,” Pamela agrees, eyeing her cake. “And just nineteen.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“This time a building society clerk. A bit of variety,” Rebecca continues.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I’m not used to this,” Pamela says. “We didn’t have mass murderers rampaging in Nottingham. This date and walnut cake looks very good.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I wouldn’t say anyone is exactly used to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You know what I mean. This is the first since I’ve been back here. I seriously considered whether I should take this job. But I thought, ‘You can’t let that put you off, Pamela’. Don’t you worry about that maniac on the loose?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“You have to have that attitude,” Rebecca says. “But we’re all a lot more wary. If I’m meeting someone, I’ll make sure it’s somewhere busy.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Me too, damn sure.” Pamela finally takes a huge bite from her slab of cake. A full thirty seconds later, “And I’m really careful around my car. Before I left this morning, you’d have thought I was checking for an IRA bomb or something.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("They laugh, drink tea.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“He tends to strike in the dead of night, not first thing in the morning,” Rebecca points out. “I do worry about Eileen though. I even wonder what will happen when Lindsay grows up and starts seeing her first boyfriend.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Oh come on, they’ve got hundreds working on this. Surely it’s only a matter of time before they catch him.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“The police aren’t exactly covering themselves in glory. There are some serious management failures if you ask me.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Talking of the police, how’s Simon?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“Simon? He’s fine, I would say.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Pamela is checking her face with a small hand mirror. “You would say?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I don’t see that much of him. For various reasons.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“And what might they be?”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Rebecca had always enjoyed her friend’s bluntness. Similar to her in that respect. “Well, I’m obviously very busy. And he’s obviously very married.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“I didn’t know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“We meet for rather short periods of time that consist of rather extended sessions of you-know-what. It’s very problematic.”")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("“So, to sum up,” Pamela laughs, “you’re probably the most successful businesswoman in Leeds. You have an amazing house, just off Roundhay Park. You’ve got a no-commitment relationship with a super handsome copper that consists of sex and little else. I think you might just have the perfect life.”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35288db0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-002.vue
// module id = 81
// module chunks = 0